import React from 'react';

import {
    DiscoveryUnit,
    DiscoveryUnitItem,
    PAGE_TYPE_SUBS_LOGGED_IN_HOMEPAGE,
} from '@udemy/discovery-api';
import {DeviceType} from '@udemy/hooks';
import {useI18n} from '@udemy/i18n';
import {DiscoveryUnitsContainer} from '@udemy/react-discovery-units';
import {AssessmentUnit} from '@udemy/react-pro-content';

interface AssessmentsDiscoveryUnitProps {
    enableAssessmentsInPersonalPlan: boolean;
    isTechLearner: boolean;
    deviceType: DeviceType;
    className?: string;
}

export const AssessmentsDiscoveryUnit: React.FC<AssessmentsDiscoveryUnitProps> = ({
    enableAssessmentsInPersonalPlan,
    isTechLearner,
    deviceType,
    className = 'component-margin',
}) => {
    const {gettext} = useI18n();

    if (!enableAssessmentsInPersonalPlan || !isTechLearner) {
        return null;
    }

    const getUnitComponentAndProps = (
        unit: Partial<DiscoveryUnit<DiscoveryUnitItem>> | undefined,
    ) => {
        if (!unit) throw new Error('Missing unit');

        return {
            component: AssessmentUnit,
            componentProps: {
                title: gettext('Evaluate your skills with assessments'),
                subtitle: gettext(
                    'Identify your proficiency level and get content recommendations based on your results.',
                ),
                uiRegion: 'assessment_unit_pp_lihp',
                isStandaloneUnit: true,
            },
        };
    };

    return (
        <div className={className} data-purpose="assessment-unit-container">
            <DiscoveryUnitsContainer
                pageType={PAGE_TYPE_SUBS_LOGGED_IN_HOMEPAGE}
                deviceType={deviceType}
                getUnitComponentAndProps={getUnitComponentAndProps}
                filter={(u) =>
                    ['assessments', 'algorithm_based_assessments_with_filter'].includes(
                        u.type || '',
                    )
                }
                disableInfiniteScroll={true}
                fetchOptions={{pageSize: 3}}
            />
        </div>
    );
};
